.fc-multicol {
  border-collapse: collapse !important;
}
.fc-multicol .fc-day-col {
  width: 75px;
}
.fc-multicol .fc-day-today {
  background-color: var(--fc-today-bg-color);
}
.fc-multicol th {
  overflow: hidden;
  padding: 2px 4px;
}
.fc-multicol .fc-events {
  padding: 2px;
  position: relative;
}
.fc-multicol .fc-event.fc-bg-event {
  border: none;
  margin: 0;
  z-index: -1;
}
.fc-multicol .fc-h-event {
  border-radius: 3px;
  display: block;
  font-size: var(--fc-small-font-size);
  margin: 1px 0 2px 0;
  overflow: hidden;
  padding: 1px 2px;
}
.fc-multicol .fc-event-meta {
  float: right;
}
.fc-multicol .fc-event-time {
  display: inline-block;
  margin-right: 3px;
  overflow: unset;
}
.fc-multicol .fc-event-location {
  display: inline-block;
}
.fc.fc-hide-empty .fc-multicol tbody tr:not(:has(.fc-event)) {
  display: none;
}
